import apiUrl from "../../../../../utils/settings";

export const loginUrl = () => {
  return apiUrl + '/auth/v2/login';
};



